import TYPES from '../../types';

// Domain
import {
  EmploymentSituationRepository,
} from '@/modules/flagship/catalogs/employment-situation/domain/repositories/employment-situation-repository';
import {
  EmploymentSituationEntity,
} from '@/modules/flagship/catalogs/employment-situation/domain/entities/employment-situation-entity';
import {
  EmploymentSituationStateManager,
} from '@/modules/flagship/catalogs/employment-situation/domain/state/employment-situation-state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class GetEmploymentSituationQuery
  extends Query<Promise<Array<EmploymentSituationEntity>>> {
  @Inject(TYPES.EMPLOYMENT_SITUATION_REPOSITORY)
  private readonly repository!: EmploymentSituationRepository;

  @Inject(TYPES.EMPLOYMENT_SITUATION_STATE_MANAGER)
  private readonly state_manager!: EmploymentSituationStateManager;

  internalExecute(): Promise<Array<EmploymentSituationEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
